import React from 'react'
import { VerticalLineProps } from './VerticalLine.types'
import styles from './VerticalLine.module.scss'
import cl from 'classnames'

const VerticalLineComponent = (props: VerticalLineProps) => {
  const {
    className,
    style
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    />
  )
}

const VerticalLine = VerticalLineComponent
export { VerticalLine }
